import { connect } from 'react-redux';
import { Button } from 'legacy/components/Button';
import { Link } from '@hc/redux-saga-router-plus';

import { VIEWS } from 'legacy/routes/constants';
import { EVENTS } from 'legacy/appstore/events';

import { analyticsEvent } from 'actions/analytics';

import {
  getIsEffectiveDateReport,
  getIsViewingSharedReport
} from 'selectors/property-explorer';
import { getSubjectLocationUnknown } from 'selectors/subject';
import { getCompsSelectionButtonView } from 'selectors/comps';
import { getRentalCompsSelectionButtonView } from 'selectors/rental-comps';

import { CompsButtons as theme } from 'legacy/css-modules';

const mapStateToProps = (state, ownProps) => {
  const isViewingShared = getIsViewingSharedReport(state);
  const isEffectiveDate = getIsEffectiveDateReport(state);
  return {
    viewComps: isEffectiveDate
      ? VIEWS.EFFECTIVE_DATE_COMPS
      : isViewingShared
      ? VIEWS.COMPS_SELECTION_SHARED
      : VIEWS.COMPS_SELECTION,
    viewRentalComps: isEffectiveDate
      ? undefined
      : isViewingShared
      ? VIEWS.RENTAL_COMPS_SELECTION_SHARED
      : VIEWS.RENTAL_COMPS_SELECTION,
    subjectLocationUnknown: getSubjectLocationUnknown(state),
    compsButtonView: getCompsSelectionButtonView(state),
    rentalCompsButtonView: getRentalCompsSelectionButtonView(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickChooseComps: () =>
      dispatch(analyticsEvent(EVENTS.COMPS_SELECT_CLICK))
  };
};

const CompsButtons = ({
  viewComps,
  viewRentalComps,
  subjectLocationUnknown,
  compsButtonView,
  rentalCompsButtonView
}) => {
  return (
    <div className={theme.CompsButtons}>
      {viewComps && (
        <Link
          view={subjectLocationUnknown ? compsButtonView : viewComps}
          options={{ inherit: true }}
          data-hc-name="map-select-comps-link"
        >
          <Button
            label={subjectLocationUnknown ? 'Draw Comp Area' : 'Select Comps'}
            className={theme.SelectCompsButton}
            dataHcName="map-select-comps-button"
          />
        </Link>
      )}
      {viewRentalComps && (
        <Link
          view={
            subjectLocationUnknown ? rentalCompsButtonView : viewRentalComps
          }
          options={{ inherit: true }}
          data-hc-name="map-select-rental-comps-link"
        >
          <Button
            label={
              subjectLocationUnknown
                ? 'Draw Rental Comp Area'
                : 'Select Rental Comps'
            }
            className={theme.SelectRentalCompsButton}
            dataHcName="map-select-rental-comps-button"
          />
        </Link>
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsButtons);
